<div class="td-wb-integration__container"
  [ngClass]="{ 'td-wb-integration__container--background-color' : config !== undefined && config.backgroundColor }">
  @if (config !== undefined && config.pageHeader !== undefined) {
    <td-wb-page-header aria-hidden="true">
      <td-wb-page-header-title [translate]="'tdWb.integration.' + config.pageHeader + '.header.TITLE'">
      </td-wb-page-header-title>
    </td-wb-page-header>
  }
  @if (config !== undefined && errorSate === false) {
    <div class="td-wb-integration__iframe-container">
      <iframe #iframe
              [title]="config.title | translate"
              name="main"
              id="main"
              class="td-wb-integration__iframe"
              (load)="onIframeLoad()"
              [ngClass]="{ 'td-wb-integration__iframe--show': !config.fixed || contentReady }"
              [src]="iframeSource"
              [height]="config.height"
              [width]="iframeWidth"
              [scrolling]="config.fixed ? 'yes' : 'no'"
              allowfullscreen
              webkitallowfullscreen
              mozallowfullscreen>
      </iframe>
    </div>
  } @else {
    <td-wb-integration-error></td-wb-integration-error>
  }
</div>
